module.exports = __webpack_public_path__ + "static/media/product_640-4.2110d8cd.jpg";